function shopifyImageUrl(url, width) {
  if (!url) return url;
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}width=${width}`;
}

window.addEventListener("DOMContentLoaded", () => {
  // set timeout because these product cards load later on PDP
  if (window.location.pathname.includes("product")) {
    setTimeout(() => {
      setSwatchSection();
      getSiblingSwatches();
    }, 1500);
  } else {
    setSwatchSection();
    getSiblingSwatches();
  }
});

document.addEventListener('pagination:page-changed', () => {
  setTimeout(() => {
    setSwatchSection();
    getSiblingSwatches();
  }, 1500);
})

function setSwatchSection() {
  const productCards = document.querySelectorAll(".product-card");

  productCards.forEach((productCard) => {
    productCard.addEventListener("mouseenter", (event) => {
      const title = event.target.querySelector(".sibling-swatches-title");
      const siblings = event.target.querySelector(".siblings");
      title?.classList.add("active");
      siblings?.classList.add("active");
    });

    productCard.addEventListener("mouseleave", (event) => {
      const title = event.target.querySelector(".sibling-swatches-title");
      const siblings = event.target.querySelector(".siblings");
      title?.classList.remove("active");
      siblings?.classList.remove("active");
    });
  });
}

function getSiblingSwatches() {
  const siblingSwatches = document.querySelectorAll(".product-card .siblings__swatch");
  siblingSwatches.forEach((siblingSwatch) => {
    siblingSwatch.addEventListener("click", (event) => {
      handleAjax(event);
    });

    siblingSwatch.addEventListener("mouseenter", (event) => {
      handleAjax(event);
    });
  });
}

// function updateSelectedValueLabel(productCard) {
//   const swatchValueLabel = productCard.querySelector(".radio__legend__value");
//   const currentSwatch = productCard.querySelector(
//     '.siblings__swatch[aria-current="true"]'
//   );

//   const siblingsButton = currentSwatch.querySelector(".siblings__button");
//   const swatchValue = siblingsButton.getAttribute("data-swatch");
//   swatchValueLabel.innerHTML = swatchValue;
// }

function deselectSwatches(productCard) {
  const siblingSwatches = productCard?.querySelectorAll(".siblings__swatch");
  siblingSwatches?.forEach((siblingSwatch) => {
    siblingSwatch.removeAttribute("aria-current");
  });
}

async function handleAjax(event) {
  event.preventDefault();
  const productCard = event.target.closest(".product-card");
  deselectSwatches(productCard);
  const selectedSwatch = event.target.closest(".siblings__swatch");
  selectedSwatch.setAttribute("aria-current", true);

  const url = window.location.href;
  const productHandle = selectedSwatch.getAttribute("href");

  // Drop query params (search results add ?_pos=…&_ss=r) so the request is /products/<handle>.js
  fetch(`${new URL(productHandle, window.location.origin).pathname}.js`)
    .then((response) => response.json())
    .then((product) => {
      //Update Title
      const { title, tags, images, featured_image, handle, variants } = product;
      const productInfo = productCard.querySelector(".product-card-info");
      const productTitle = productInfo.querySelector(".product-card-title");

      productTitle.innerHTML = title;
      productTitle.setAttribute("title", title);

      //Update Price
      const productPrice = productCard.querySelector(".price");
      const price = product.variants[0].price;
      const comparePrice = product.variants[0].compare_at_price;

      const priceElement = productPrice.querySelector("ins");
      const comparePriceElement = productPrice.querySelector("del");

      priceElement.innerHTML = `<span class="amount">$${(price / 100).toFixed(
        2
      )}</span`;

      if (comparePriceElement) {
        comparePriceElement.remove();
      }

      if (comparePrice) {
        productPrice.insertAdjacentHTML(
          "afterbegin",
          `<del><span class="amount">$${(comparePrice / 100).toFixed(
            2
          )}</span></del>`
        );
      }

      //Update Images
      const featuredImageWrapper = productCard.querySelector(
        ".product-featured-image-link"
      );

      featuredImageWrapper.setAttribute("title", title);
      featuredImageWrapper.setAttribute("href", `/products/${handle}`);
      featuredImageWrapper.innerHTML = "";

      // Rebuild images inside a track wrapper so the hover (desktop) and
      // scroll-snap carousel (mobile) behaviors match the server-rendered markup.
      const imageTrack = document.createElement("div");
      imageTrack.className = "product-featured-image-track";
      featuredImageWrapper.appendChild(imageTrack);

      images.forEach((image, index) => {
        if (index !== 0 && index <= 4) {
          imageTrack.insertAdjacentHTML(
            "beforeend",
            `<img class="product-secondary-image" data-index="${index}" width="770" height="962" src="${shopifyImageUrl(image, 770)}" srcset="${shopifyImageUrl(image, 375)} 375w, ${shopifyImageUrl(image, 770)} 770w" sizes="(min-width: 750px) 375px, 100vw" alt="${title}">`
          );
        }
      });

      imageTrack.insertAdjacentHTML(
        "beforeend",
        `<img class="product-primary-image" width="770" height="962" src="${shopifyImageUrl(featured_image, 770)}" srcset="${shopifyImageUrl(featured_image, 375)} 375w, ${shopifyImageUrl(featured_image, 770)} 770w" sizes="(min-width: 750px) 375px, 100vw" alt="${title}" style="object-position: 50.0% 50.0%;">`
      );

      // Secondary Nav
      const imageNav = productCard.querySelector(
        ".product-secondary-images-nav"
      );

      imageNav.innerHTML = "";
      images.forEach((_, index) => {
        if (index !== 0 && index <= 4) {
          imageNav.insertAdjacentHTML("beforeend", `<li data-index="${index}"></li>`);
        }
      });

      // function from app.js
      enableAdditionalImages(productCard);

      const productBadgeContainer = productCard.querySelector(".product-card--badges");

      //Update Badge
      if(window.custom_product_badge_sale_show == true){


        productBadgeContainer.innerHTML = "";
  
        if (tags.includes("Best Seller")) {
          productBadgeContainer.innerHTML = `<div class="badge best-seller">
            Best Seller
          </div>`;
        }
  
        if (comparePrice) {
          productBadgeContainer.innerHTML = `<span class="badge onsale">Save $${(
            comparePrice / 100 -
            price / 100
          ).toFixed(2)}
          </span>`;
  
          if (tags.includes("Final Sale")) {
            productBadgeContainer.insertAdjacentHTML(
              "beforeend",
              `<div class="badge final-sale">
              FINAL SALE
            </div>`
            );
          }
        }
      }
      // Updates custom badges 
      let customBadge = selectedSwatch.getAttribute('data-custom-badge')  
      if(productBadgeContainer){
        const existingCustomBadges = productBadgeContainer.querySelectorAll('.badge.custom-badge') 
        if(existingCustomBadges && existingCustomBadges.length > 0){
          // Remove any existing custom badges from previous swatch selection 
          existingCustomBadges.forEach(badge => { 
            badge.remove();
        }); 
        }
      }       
      if(customBadge){ 
        // Add new custom badges, if they exist on new swatch selection
        productBadgeContainer.insertAdjacentHTML(
          "beforeend",
          `${customBadge}`
        );
      }

      // Not clear if Out of stock products will be selectible from swatches
      // Out of Stock Badging could be needed here if that changes

      // Update Variants + add to cart
      const variantSelector = productCard.querySelector(".product-card-sizes");

      productCard.querySelector('[type="application/json"]').innerText =
        JSON.stringify(variants);

      variantSelector.setAttribute(
        "data-options",
        variants[0].title.split(" / ").join(",")
      );

      variantSelector.innerHTML = "";

      variants.forEach((variant, index) => {
        if (index <= 15) {
          variantSelector.insertAdjacentHTML(
            "beforeend",
            // Sold-out sizes arrive crossed-out so they don't flash as available before setDisabled runs
            `<div class="product-card-sizes--size${variant.available ? "" : " is-disabled"}" >
              <span>${variant.option2}</span><div class="loading-overlay">
              <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="var(--color-accent)"></circle>
              </svg>
            </div>
          </div>`
          );
        }
      });
      // sizes remaining
      const sizesRemaining = productCard.querySelector(
        ".product-card-sizes--remaining"
      );
      if (sizesRemaining) {
        sizesRemaining.innerText = `+${variants.length - 15}`;
      }
      // function from app.js
      enableSizeOptions(productCard);
      applyGridAlignment([productCard]);
    });
}

function enableAdditionalImages(productCard) {
  let images = productCard.querySelectorAll(".product-secondary-image");
  let nav = productCard.querySelector(".product-secondary-images-nav");
  let navItems = nav ? nav.querySelectorAll("li") : [];
  let track = productCard.querySelector(".product-featured-image-track");

  const clearAll = () => {
    images.forEach((image) => image.classList.remove("hover"));
    navItems.forEach((dot) => dot.classList.remove("active"));
  };

  const showByIndex = (index) => {
    if (index === null || index === undefined) return;
    clearAll();
    const selimg = productCard.querySelector(
      '.product-secondary-image[data-index="' + index + '"]'
    );
    const seldot = productCard.querySelector(
      '.product-secondary-images-nav li[data-index="' + index + '"]'
    );
    if (selimg) selimg.classList.add("hover");
    if (seldot) seldot.classList.add("active");
  };

  if (window.matchMedia("(max-width: 768px)").matches) {
    // Mobile: keep the nav dots in sync with the scroll-snap carousel.
    if (track) {
      let ticking = false;
      const syncDots = () => {
        const slideWidth = track.clientWidth || 1;
        const index = Math.round(track.scrollLeft / slideWidth);
        navItems.forEach((dot) => dot.classList.remove("active"));
        const dot = productCard.querySelector(
          '.product-secondary-images-nav li[data-index="' + index + '"]'
        );
        if (dot) dot.classList.add("active");
      };
      track.addEventListener(
        "scroll",
        () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            ticking = false;
            syncDots();
          });
        },
        { passive: true }
      );
      syncDots();
    }
  } else {
    // Desktop: hover a dot to show its image; anywhere else shows the first.
    const hover_root =
      productCard.querySelector(".product-featured-image") || productCard;
    const firstIndex = navItems.length
      ? navItems[0].getAttribute("data-index")
      : images.length
      ? images[0].getAttribute("data-index")
      : null;
    const onOver = (e) => {
      const dot = e.target.closest(".product-secondary-images-nav li");
      showByIndex(dot ? dot.getAttribute("data-index") : firstIndex);
    };
    hover_root.addEventListener("mouseover", onOver, { passive: true });
    hover_root.addEventListener("mouseleave", clearAll, { passive: true });
  }

  images.forEach(function (image) {
    window.addEventListener("load", (event) => {
      lazySizes.loader.unveil(image);
    });
  });
}

function enableSizeOptions(productCard) {
  const size_options = productCard.querySelector(".product-card-sizes");
  let size_list = size_options.querySelectorAll(".product-card-sizes--size"),
    featured_image = productCard.querySelector(".product-featured-image"),
    has_hover = featured_image.classList.contains("thb-hover"),
    size_parent = size_options.parentElement;

  const size_index = size_options.dataset.index;

  const current_options = size_options.dataset.options.split(",");

  updateMasterId(current_options, size_options, productCard, size_index);

  size_parent.addEventListener(
    "mouseenter",
    () => {
      if (has_hover) {
        featured_image.classList.remove("thb-hover");
      }
    },
    {
      passive: true,
    }
  );
  size_parent.addEventListener(
    "mouseleave",
    () => {
      if (has_hover) {
        featured_image.classList.add("thb-hover");
      }
    },
    {
      passive: true,
    }
  );
  size_list.forEach((size) => {
    size.addEventListener("click", (evt) => {
      evt.preventDefault();

      if (size.classList.contains("is-disabled")) {
        return;
      }
      current_options[size_index] = size.querySelector("span").innerText;
      const currentVariant = updateMasterId(
        current_options,
        size_options,
        productCard,
        size_index
      );

      size.classList.add("loading");
      size.setAttribute("aria-disabled", true);
      const config = {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/javascript",
        },
      };
      let formData = new FormData();

      formData.append("id", currentVariant.id);
      formData.append("quantity", 1);
      formData.append(
        "sections",
        getSectionsToRender().map((section) => section.section)
      );
      formData.append("sections_url", window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          renderContents(response);

          dispatchCustomEvent("cart:item-added", {
            product: response.hasOwnProperty("items")
              ? response.items[0]
              : response,
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          size.classList.remove("loading");
          size.removeAttribute("aria-disabled");
        });
    });
  });
}

function updateMasterId(
  current_options,
  size_options,
  productCard,
  size_index
) {
  const currentVariant = getVariantData(productCard).find((variant) => {
    return !variant.title
      .split(" / ")
      .map((option, index) => {
        return current_options[index] === option;
      })
      .includes(false);
  });
  setTimeout(() => {
    setDisabled(currentVariant, size_options, productCard, size_index);
  }, 100);
  return currentVariant;
}

function getVariantData(productCard) {
  const variantData = JSON.parse(
    productCard.querySelector('[type="application/json"]').textContent
  );
  return variantData;
}

function setDisabled(currentVariant, size_options, productCard, size_index) {
  const variant_data = getVariantData(productCard);

  if (variant_data) {
    if (currentVariant) {
      const selected_options = currentVariant.title
        .split(" / ")
        .map((value, index) => {
          return {
            value,
            index: `option${index + 1}`,
          };
        });

      const available_options = createAvailableOptionsTree(
        variant_data,
        selected_options,
        currentVariant
      );

      const fieldset_options = Object.values(available_options)[size_index];
      if (fieldset_options) {
        if (size_options.querySelectorAll(".product-card-sizes--size").length) {
          size_options
            .querySelectorAll(".product-card-sizes--size")
            .forEach((input, input_i) => {
              input.classList.toggle(
                "is-disabled",
                fieldset_options[input_i].isUnavailable
              );
            });
        }
      }
    } else {
      if (size_options.querySelectorAll(".product-card-sizes--size").length) {
        size_options
          .querySelectorAll(".product-card-sizes--size")
          .forEach((input, input_i) => {
            input.classList.add("is-disabled");
          });
      }
    }
  }
  return true;
}

function createAvailableOptionsTree(
  variant_data,
  selected_options,
  currentVariant
) {
  // Reduce variant array into option availability tree
  return variant_data.reduce(
    (options, variant) => {
      // Check each option group (e.g. option1, option2, option3) of the variant
      Object.keys(options).forEach((index) => {
        if (variant[index] === null) return;

        let entry = options[index].find(
          (option) => option.value === variant[index]
        );

        if (typeof entry === "undefined") {
          // If option has yet to be added to the options tree, add it
          entry = {
            value: variant[index],
            isUnavailable: true,
          };
          options[index].push(entry);
        }

        // Check how many selected option values match a variant
        const countVariantOptionsThatMatchCurrent = selected_options.reduce(
          (count, { value, index }) => {
            return variant[index] === value ? count + 1 : count;
          },
          0
        );

        // Only enable an option if an available variant matches all but one current selected value
        if (
          countVariantOptionsThatMatchCurrent >=
          selected_options.length - 1
        ) {
          entry.isUnavailable =
            entry.isUnavailable && variant.available
              ? false
              : entry.isUnavailable;
        }

        // Make sure if a variant is unavailable, disable currently selected option
        if (
          (!currentVariant || !currentVariant.available) &&
          selected_options.find(
            (option) => option.value === entry.value && index === option.index
          )
        ) {
          entry.isUnavailable = true;
        }

        // First option is always enabled
        if (index === "option1") {
          entry.isUnavailable =
            entry.isUnavailable && variant.available
              ? false
              : entry.isUnavailable;
        }
      });

      return options;
    },
    {
      option1: [],
      option2: [],
      option3: [],
    }
  );
}

function getSectionsToRender() {
  return [
    {
      id: "Cart",
      section: "main-cart",
      selector: ".thb-cart-form",
    },
    {
      id: "Cart-Drawer",
      section: "cart-drawer",
      selector: ".cart-drawer",
    },
    {
      id: "cart-drawer-toggle",
      section: "cart-bubble",
      selector: ".thb-item-count",
    },
  ];
}

function renderContents(parsedState) {
  getSectionsToRender().forEach((section) => {
    if (!document.getElementById(section.id)) {
      return;
    }
    const elementToReplace =
      document.getElementById(section.id).querySelector(section.selector) ||
      document.getElementById(section.id);
    elementToReplace.innerHTML = getSectionInnerHTML(
      parsedState.sections[section.section],
      section.selector
    );
    if (typeof CartDrawer !== "undefined") {
      new CartDrawer();
    }
    if (typeof Cart !== "undefined") {
      new Cart().renderContents(parsedState);
    }
  });

  if (document.getElementById("Cart-Drawer")) {
    document.getElementById("Cart-Drawer").classList.add("active");
    document.body.classList.add("open-cart");
    document.body.classList.add("open-cc");
    if (
      document
        .getElementById("Cart-Drawer")
        .querySelector(".product-recommendations--full")
    ) {
      document
        .getElementById("Cart-Drawer")
        .querySelector(".product-recommendations--full")
        .classList.add("active");
    }
    dispatchCustomEvent("cart-drawer:open");
  }
}

function getSectionInnerHTML(html, selector = ".shopify-section") {
  return new DOMParser()
    .parseFromString(html, "text/html")
    .querySelector(selector).innerHTML;
}

//Center Align Size options if qty of sizes is <=8

// Function to apply the grid alignment logic
function applyGridAlignment(productCards) {
  productCards.forEach((productCard, index) => {
    // Find the grid container within this product card
    const gridContainer = productCard.querySelector('.product-card-sizes');
    
    // Find the parent container for the grid items
    const container = productCard.querySelector('.product-card-sizes--container');
    
    // Check if gridContainer and container exist
    if (gridContainer && container) {
      // Get the number of child elements (grid items)
      const gridItems = gridContainer.children.length;
            

      // Add or remove 'center-align' class based on the number of items
      if (gridItems <= 8) {
        container.classList.add('center-align');
      } else {
        container.classList.remove('center-align');
      }
    }
  });
}

// Initial load - Apply the grid alignment to the first set of products
applyGridAlignment(document.querySelectorAll('.product-card.text-left'));

// Listen for the custom event dispatched when new products are loaded
document.addEventListener('pagination:page-changed', function () {
  
  // Reapply the grid alignment logic to the newly added products
  const newProductCards = document.querySelectorAll('.product-card.text-left');
  applyGridAlignment(newProductCards);
});
